import ReactGA from "react-ga4";

export const resetChallenge = () => {
  localStorage.removeItem("ChallengeIndex");
  window.location.reload();
};

export const toAmazon = () => {
  const path = "https://amzn.to/3WVj5oP";
  ReactGA.event("page_link2", { path });
  window.location.href = path;
};
